const ENV = "PROD";

const configs = {
  LOCAL: {
    apiBaseUrl: "http://localhost:3001",
    apichKey: "my_campushunt_api_key",
    map_key: "AIzaSyDroIe2t8dpwfnDOM0glVjBz3o37bOwHf8"
  },
  PROD: {
    apiBaseUrl: "https://api.campushunt.in",
    apichKey: "my_campushunt_api_key",
    map_key: "AIzaSyDroIe2t8dpwfnDOM0glVjBz3o37bOwHf8"
  }

};

const config = () => configs[ENV];

const configModule = { config };

export default configModule;

